var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "hb-section",
    {
      staticClass: "performance-strip",
      attrs: { title: _vm.title, subtitle: _vm.subtitle },
    },
    [
      _c(
        "div",
        { staticClass: "performance-strip__grid" },
        [
          _c(
            "hb-metric",
            {
              attrs: {
                label: _vm.$t("influencer_panel.clicks"),
                delta: _vm.delta("clicks"),
              },
            },
            [_vm._v(" " + _vm._s(_vm.number(_vm.metrics.clicks)) + " ")]
          ),
          _c(
            "hb-metric",
            {
              attrs: {
                label: _vm.$t("influencer_panel.conversions"),
                delta: _vm.delta("conversions"),
              },
            },
            [_vm._v(" " + _vm._s(_vm.number(_vm.metrics.conversions)) + " ")]
          ),
          _c(
            "hb-metric",
            {
              attrs: {
                label: _vm.$t("influencer_panel.conversion_rate"),
                delta: _vm.conversionDelta,
                unit: "pp",
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.percent(_vm.metrics.conversion_rate)) + " "
              ),
            ]
          ),
          _c(
            "hb-metric",
            {
              attrs: {
                label: _vm.$t("influencer_panel.gmv"),
                delta: _vm.delta("gmv_cents"),
              },
            },
            [_c("hb-money", { attrs: { cents: _vm.metrics.gmv_cents } })],
            1
          ),
          _c(
            "hb-metric",
            {
              attrs: {
                label: _vm.$t("influencer_panel.commission"),
                delta: _vm.delta("commission_total_cents"),
              },
            },
            [
              _c("hb-money", {
                attrs: { cents: _vm.metrics.commission_total_cents },
              }),
            ],
            1
          ),
          _c(
            "hb-metric",
            {
              attrs: {
                label: _vm.$t("influencer_panel.avg_ticket"),
                delta: _vm.delta("avg_ticket_cents"),
              },
            },
            [
              _c("hb-money", {
                attrs: { cents: _vm.metrics.avg_ticket_cents },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.metrics.clicks_source === "lifetime"
        ? _c(
            "p",
            { staticClass: "performance-strip__note" },
            [
              _c("feather-icon", { attrs: { icon: "InfoIcon", size: "13" } }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("influencer_panel.period_all_clicks_hint")) +
                  " "
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }